var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6665 21.9998C3.6665 11.8746 11.8746 3.6665 21.9998 3.6665C32.1251 3.6665 40.3332 11.8746 40.3332 21.9998C40.3332 27.5257 37.8884 32.4806 34.0215 35.8418C33.1824 33.5958 31.7274 31.6213 29.8122 30.1518C27.5709 28.432 24.8248 27.4998 21.9998 27.4998C19.1747 27.4998 16.4286 28.432 14.1873 30.1518C12.2722 31.6213 10.8171 33.5957 9.97803 35.8417C6.1112 32.4805 3.6665 27.5256 3.6665 21.9998ZM30.8541 37.9606C30.8616 37.9887 30.8697 38.0163 30.8784 38.0437C28.2479 39.5025 25.2209 40.3332 21.9998 40.3332C18.7787 40.3332 15.7516 39.5025 13.1211 38.0436C13.1298 38.0163 13.1379 37.9886 13.1454 37.9606C13.6677 36.0115 14.8185 34.2892 16.4194 33.0607C18.0204 31.8323 19.9819 31.1665 21.9998 31.1665C24.0177 31.1665 25.9792 31.8323 27.5801 33.0607C29.181 34.2892 30.3318 36.0115 30.8541 37.9606ZM18.3331 16.4998C18.3331 14.4748 19.9747 12.8331 21.9998 12.8331C24.0248 12.8331 25.6664 14.4748 25.6664 16.4998C25.6664 18.5249 24.0248 20.1665 21.9998 20.1665C19.9747 20.1665 18.3331 18.5249 18.3331 16.4998ZM21.9998 9.16648C17.9497 9.16648 14.6664 12.4497 14.6664 16.4998C14.6664 20.5499 17.9497 23.8331 21.9998 23.8331C26.0498 23.8331 29.3331 20.5499 29.3331 16.4998C29.3331 12.4497 26.0498 9.16648 21.9998 9.16648Z",
    fill: "#8794A5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.58317,
    y: 4.58317,
    width: 34.8333,
    height: 34.8333,
    rx: 17.4167,
    stroke: "#8794A5",
    strokeWidth: 1.83333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.406295e27dee78289a3c2734ff54f8e0.svg";
export { ForwardRef as ReactComponent };